import {useQuery} from "@tanstack/react-query";

import {getSupplierQueryOptions} from "./get-supplier.query-options";

export function useGetSupplier(id: string, includeDeleted = false) {
  return useQuery(getSupplierQueryOptions(id, includeDeleted));
}
